export default {"src":"/_next/static/media/arrow-narrow-down.c38729e6.svg","height":24,"width":24};